(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartUrl = root + 'cart';
  var money = function (cents) {
    var fmt = (window.WB && window.WB.moneyFormat) || '{{amount_with_comma_separator}} €';
    var v = (cents / 100).toFixed(2);
    var comma = v.replace('.', ',');
    var parts = comma.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(','))
      .replace(/\{\{\s*amount\s*\}\}/, v)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };
  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };

  function addItems(items, btn) {
    if (!items.length) return;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.dataset.label = btn.textContent; btn.textContent = 'Ajout…'; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      window.location.href = cartUrl;
    }).catch(function (e) {
      if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = btn.dataset.label; }
      alertBox(btn, (e && (e.description || e.message)) || 'Impossible d’ajouter au panier. Réessaie.');
    });
  }
  function alertBox(near, msg) {
    var box = document.createElement('div');
    box.className = 'note-err'; box.setAttribute('role', 'alert'); box.textContent = msg;
    if (near && near.parentNode) near.parentNode.insertBefore(box, near.nextSibling);
    setTimeout(function () { box.remove(); }, 6000);
  }

  // Gallery
  $$('[data-gal]').forEach(function (gal) {
    var main = $('.js-gal-main', gal);
    $$('[data-gal-thumb]', gal).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!main) return;
        main.src = b.dataset.src; main.removeAttribute('srcset'); main.alt = b.dataset.alt || main.alt;
        $$('[data-gal-thumb]', gal).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  });

  // Qty steppers
  $$('[data-qty]').forEach(function (q) {
    var input = $('input', q);
    $$('[data-step]', q).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10));
        input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Variant picker
  $$('.js-product-form').forEach(function (form) {
    var json = $('[data-product-json]', form.closest('[data-pdp]') || document);
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var idInput = $('input[name="id"]', form);
    var pdp = form.closest('[data-pdp]') || document;
    var btn = $('[data-add-btn]', form);
    function current() {
      var sel = [];
      $$('[data-opt]', form).forEach(function (fs) {
        var c = $('input:checked', fs); sel[parseInt(fs.dataset.opt, 10)] = c ? c.value : null;
      });
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] == null || sel[i] === o; }); });
    }
    function markAvailability() {
      $$('[data-opt]', form).forEach(function (fs) {
        var idx = parseInt(fs.dataset.opt, 10);
        $$('input', fs).forEach(function (inp) {
          var ok = product.variants.some(function (v) {
            if (!v.available || v.options[idx] !== inp.value) return false;
            return $$('[data-opt]', form).every(function (fs2) {
              var j = parseInt(fs2.dataset.opt, 10); if (j === idx) return true;
              var c = $('input:checked', fs2); return !c || v.options[j] === c.value;
            });
          });
          inp.closest('label').classList.toggle('is-out', !ok);
        });
      });
    }
    function update() {
      var v = current();
      $$('[data-opt]', form).forEach(function (fs) {
        var c = $('input:checked', fs); var out = $('[data-opt-val]', fs); if (out && c) out.textContent = c.value;
      });
      markAvailability();
      if (!v) {
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.disabled = true; btn.textContent = 'Combinaison indisponible'; }
        return;
      }
      idInput.value = v.id;
      $$('[data-price]', pdp).forEach(function (el) { el.textContent = money(v.price); });
      $$('[data-compare]', pdp).forEach(function (el) {
        if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = money(v.compare_at_price); el.hidden = false; } else { el.hidden = true; }
      });
      $$('[data-variant-title]', pdp).forEach(function (el) { el.textContent = v.title === 'Default Title' ? '' : v.title; });
      if (btn) {
        btn.disabled = !v.available;
        if (v.available) { btn.removeAttribute('aria-disabled'); btn.textContent = 'Ajouter au panier · ' + money(v.price); }
        else { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Épuisé dans cette version'; }
      }
      $$('[data-sticky-btn]', pdp).forEach(function (b) { b.disabled = !v.available; });
      if (v.featured_image) {
        var main = $('.js-gal-main', pdp);
        if (main) { main.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1100'; main.removeAttribute('srcset'); }
      }
      $$('[data-base-item]', pdp).forEach(function (el) { el.dataset.vid = v.id; el.dataset.price = v.price; el.dispatchEvent(new Event('change', { bubbles: true })); });
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
    $$('[data-opt] input', form).forEach(function (i) { i.addEventListener('change', update); });
    markAvailability();
    $$('[data-sticky-btn]', pdp).forEach(function (b) { b.addEventListener('click', function () { if (btn) btn.click(); }); });
  });

  // Multi-add (cross-sell, configurator)
  $$('[data-multi]').forEach(function (box) {
    var promo = box.dataset.promo === '1';
    var pct = parseFloat(box.dataset.pct || (window.WB && window.WB.promoPercent) || '10');
    var fixed = parseInt(box.dataset.fixed || '0', 10);
    var min = parseInt(box.dataset.min || '1', 10);
    function all() { return $$('input[data-vid]', box).filter(function (i) { return !i.disabled; }); }
    function picked() { return all().filter(function (i) { return i.checked; }); }
    function refresh() {
      var p = picked(); var n = p.length; var raw = 0;
      p.forEach(function (i) { raw += parseInt(i.dataset.price, 10) || 0; });
      $$('input[data-vid]', box).forEach(function (i) { var row = i.closest('.xrow'); if (row) row.classList.toggle('is-on', i.checked); });
      var disc = 0;
      if (promo) {
        var kit = all().filter(function (i) { return !i.closest('[data-extra]'); });
        var kitOn = kit.length >= 2 && kit.every(function (i) { return i.checked; });
        var kitRaw = 0; kit.forEach(function (i) { kitRaw += parseInt(i.dataset.price, 10) || 0; });
        if (n >= 2) disc = Math.round(raw * pct / 100);
        if (fixed > 0 && kitOn && kitRaw - fixed > disc) disc = kitRaw - fixed;
      }
      var extra = n - $$('input[data-base-item]:checked', box).length;
      $$('[data-multi-count]', box).forEach(function (el) { el.textContent = n; });
      $$('[data-multi-extra]', box).forEach(function (el) { el.textContent = extra; });
      $$('[data-multi-raw]', box).forEach(function (el) { el.textContent = money(raw); });
      $$('[data-multi-total]', box).forEach(function (el) { el.textContent = money(raw - disc); });
      $$('[data-multi-save]', box).forEach(function (el) { el.hidden = disc <= 0; var t = $('[data-multi-save-val]', el); if (t) t.textContent = money(disc); });
      $$('[data-multi-hint]', box).forEach(function (el) { el.hidden = !promo || n !== 1; });
      $$('[data-multi-lines]', box).forEach(function (el) {
        el.innerHTML = '';
        p.forEach(function (i) {
          var li = document.createElement('div'); li.className = 'sum__line';
          var a = document.createElement('span'); a.textContent = i.dataset.name || ''; var b = document.createElement('span'); b.textContent = money(parseInt(i.dataset.price, 10) || 0);
          li.appendChild(a); li.appendChild(b); el.appendChild(li);
        });
      });
      $$('[data-multi-add]', box).forEach(function (b) {
        var ok = n >= min;
        b.disabled = !ok;
        if (b.dataset.plural) b.textContent = !ok ? b.dataset.empty : (n === 1 ? b.dataset.single : b.dataset.plural.replace('%n', n)) + ' · ' + money(raw - disc);
      });
    }
    $$('input[data-vid]', box).forEach(function (i) { i.addEventListener('change', refresh); });
    $$('[data-multi-all]', box).forEach(function (b) { b.addEventListener('click', function () { all().forEach(function (i) { i.checked = true; }); refresh(); }); });
    $$('[data-multi-add]', box).forEach(function (b) {
      b.addEventListener('click', function () { addItems(picked().map(function (i) { return { id: parseInt(i.dataset.vid, 10), quantity: 1 }; }), b); });
    });
    refresh();
  });

  // One-click pack / single add
  $$('[data-add-ids]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var ids = (b.dataset.addIds || '').split(',').filter(Boolean);
      addItems(ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }), b);
    });
  });

  // Boat tabs
  $$('[data-boat-tabs]').forEach(function (wrap) {
    var tabs = $$('[data-boat-tab]', wrap);
    var panels = $$('[data-boat-panel]', wrap);
    function show(i) {
      tabs.forEach(function (t) { var on = t.dataset.boatTab === String(i); t.setAttribute('aria-selected', on ? 'true' : 'false'); t.classList.toggle('chip--on', on); t.tabIndex = on ? 0 : -1; });
      panels.forEach(function (p) { p.hidden = p.dataset.boatPanel !== String(i); });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.boatTab); }); });
    var want = new URLSearchParams(window.location.search).get('bateau');
    var start = tabs.find(function (t) { return want && t.dataset.slug === want; });
    show(start ? start.dataset.boatTab : (tabs[0] && tabs[0].dataset.boatTab));
  });

  // Boat finder (home)
  $$('[data-finder]').forEach(function (f) {
    var sel = $('select', f); var go = $('[data-finder-go]', f);
    function set() { var o = sel.options[sel.selectedIndex]; go.href = o.value; var l = $('[data-finder-label]', go); if (l) l.textContent = o.dataset.label; }
    sel.addEventListener('change', set); set();
  });

  // "Bientôt" toggles feed the newsletter tags
  $$('[data-soon-box]').forEach(function (box) {
    var tags = $('input[name="contact[tags]"]', box); var cta = $('[data-soon-cta]', box);
    var baseTags = tags ? tags.value : '';
    $$('[data-soon]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        var on = $$('[data-soon][aria-pressed="true"]', box);
        if (tags) tags.value = [baseTags].concat(on.map(function (x) { return x.dataset.soon; })).join(',');
        if (cta) cta.textContent = on.length ? 'Me prévenir (' + on.length + ')' : cta.dataset.all;
      });
    });
  });

  // Cart discount code
  $$('[data-disc-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var c = ($('input', f).value || '').trim(); if (!c) return;
      window.location.href = root + 'discount/' + encodeURIComponent(c) + '?redirect=' + encodeURIComponent(cartUrl);
    });
  });

  // Collection sort
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString(); });
  });
})();
